const GREY = {
  main: '#5C5C5C',
  secondary: '#C9D1D9',
  third: '#ebf1f0',
  fourth: '#6e768166',
  light: '#F1F1F1',
  dark: '#999',
  darker: '#8B949E',
  highlight_dark: 'rgba(255, 255, 255, 0.16)',
  highlight_light: '#666',
  highlight_lighter: '#D2D2D2',
  button_dark: '#353b42',
  button_light: '#eaecee',
}

const BLACK = {
  main: '#000',
}

const NEUTRAL = {
  white: '#FFFFFF',
  input: '#1a3746',
  first: '#ffffff',
  second: 'rgba(4, 71, 68, 0.20)',
  third: '#00000060',
  dark: '#161b22',
  darker: '#002031',
  light: '#f9f9f9',
  lighter: '#2f353c',
}

const RED = {
  main: '#dc3545',
  light: '#fff2f2',
  dark: '#fff2f2',
  notify: '#d63384',
  error: '#ff424a',
}

const YELLOW = {
  main: '#fee71e',
}

const BLUE = {
  main: '#0969DA',
  secondary: '#58A6FF',
  dark: '#2c5cc6',
  light: '#3a87e1',
  lighter: '#0d6efd',
}

const GREEN = {
  main: '#004744',
  default: '#002031',
  second: '#9bb5b4',
}

const SLA_STATE = {
  overdue_light: '#ff6060',
  overdue_dark: '#391f24',
  on_time_light: '#e0f5f0',
  on_time_dark: '#333a3e',
}

const PRIORITY = {
  low: '#c8c8c8',
  urgent: '#e3ad0b',
  normal: '#2c5cc6',
  emergency: '#dc3545',
}

const STATUS = {
  request: '#cea0cc',
  new: '#81bef7',
  in_progress: '#6ca669',
  on_hold: '#fa9863',
  solution_offer: '#989995',
  closed: '#222222',
}

const BORDER = {
  dark: '#283d43',
  light: '#D7D7D7',
  darkBold: '#f0f6fc1a',
  darker: '#21262d',
  darkerBold: '#1b1f2426',
  devider: '#d8dee4',
}

// lấy màu bằng cách vào trang https://coolors.co/ => chọn tool tạo palette từ hình ảnh => xuất ra dưới dạng css

const TAGS_BACKGROUND_DARK = {
  amaranth_purple: '#310e13',
  pear: '#34311f',
  violet_blue: '#161d34',
  sea_green: '#0d251f',
  saffron: '#37301a',
  mauveine: '#251432',
  spanish_orange: '#362113',
  golden_gate_bridge: '#310e13',
  dogwood_rose: '#321324',
  persian_green: '#0b292c',
  carrot_orange: '#362913',
  kelly_green: '#212e1f',
  dim_gray: '#1c1f24',
  wisteria: '#282133',
  engineering_orange: '#310e13',
  glaucous: '#212638',
  celestial_blue: '#17263f',
  coffee: '#211d20',
  amethyst: '#282133',
  azure: '#0c2a3c',
  light_coral: '#342428',
  light_saffron: '#37301a',
  khaki: '#292a2d',
  mint: '#142f29',
  pigment_green: '#112C1Eff',
  tang_blue: '#131F35ff',
  goldenrod: '#362C17ff',
}

const TAGS_BACKGROUND_LIGHT = {
  pear: '#C0CA33ff',
  violet_blue: '#3F51B2ff',
  amaranth_purple: '#AD1457ff',
  sea_green: '#0A8043ff',
  saffron: '#E5C343ff',
  mauveine: '#8D24AAff',
  spanish_orange: '#EF6C00ff',
  golden_gate_bridge: '#F1521Eff',
  dogwood_rose: '#D51B60ff',
  persian_green: '#029686ff',
  carrot_orange: '#EE9301ff',
  kelly_green: '#7DB343ff',
  dim_gray: '#616161ff',
  wisteria: '#B39DDDff',
  engineering_orange: '#D50000ff',
  glaucous: '#7986CBff',
  celestial_blue: '#039BE6ff',
  coffee: '#765647ff',
  amethyst: '#9E69AFff',
  azure: '#4286F5ff',
  light_coral: '#E77B75ff',
  light_saffron: '#F4C023ff',
  khaki: '#A59B8Fff',
  mint: '#34B57Aff',
  tang_blue: '#2B5DC6ff',
  pigment_green: '#22A848ff',
  goldenrod: '#E0AD0Cff',
}

export const AppPalette = {
  GREY,
  BLACK,
  BLUE,
  RED,
  GREEN,
  YELLOW,
  SLA_STATE,
  STATUS,
  PRIORITY,
  TAGS_BACKGROUND_LIGHT,
  TAGS_BACKGROUND_DARK,
  NEUTRAL,
  BORDER,
}

/**
 * Small red text (reasons, inline errors) for each theme. The palette's
 * `error.main` is near-white (#fff2f2) in both modes, so it cannot be used;
 * #dc3545 only reaches 3.71:1 on the dark ground, too low for 11–12px text.
 */
export const ERROR_TEXT = { light: '#dc3545', dark: '#FDA29B' } as const
